import React, { useState, useEffect } from "react";
import Input from "../../Resources/Forms/Input";
import Button from "../../Resources/Forms/Button";
import Radio from "../../Resources/Forms/Radio";
import "../../Styles/Pages/firsttimeorder.scss";
import OutletPhoto from "./OutletPhoto";
import CompletionRing from "../../Accounts/CompletionRing";
import dayjs from "dayjs";
import { GET, POST } from "../../Utils/api";
import { Fragment } from "react";
import { asset_url } from "../../app-config";
import Loading from "../../Loaders/Loading";
import UpdateCustomerLocation from "../Tools/UpdateCustomerLocation";
import {
	_getLocationDistances,
	_formatCurrency,
	_capitalizeText,
} from "../../Utils/helpers";

const CallAgentVerification = props => {
	const [step, setStep] = useState(1);
	const [storeAddress, setStoreAddress] = useState("");
	const [fullName, setFullName] = useState("");
	const [storeName, setStoreName] = useState("");
	const [isConfirmRetailStore, setConfirmRetailStore] = useState("YES");
	const [isConfirmCustomerLocation, setConfirmCustomerLocation] = useState(
		"YES",
	);
	const [retailStoreData, setRetailStoreData] = useState({});
	const [storeImages, setStoreImages] = useState([]);
	const [showLoader, setShowLoader] = useState(false);
	const [showLoading, setShowLoading] = useState(true);
	const [updateCustomerLocation, setupdateCustomerLocation] = useState(false);
	const [longitude, setLongitude] = useState(
		Number(props.context.userLocation.longitude || "0"),
	);
	const [latitude, setLatitude] = useState(
		Number(props.context.userLocation.latitude || "0"),
	);

	useEffect(() => {
		GetRetailStoreVerificationData();
	}, []);
	const getAddress = async () => {
		setConfirmCustomerLocation("NO");
		if (!props.context.userLocation.longitude) {
			navigator.geolocation.watchPosition(
				position => {
					window.location.reload();
				},
				error => {
					props.context.showAlert("Please enable GPS access", "error");
				},
			);
		}
	};
	const submitSteps = flag => {
		switch (step) {
			case 1:
				flag === 1 && EditRetailStoreVerificationData(1);
				break;
			case 2:
				flag === 1 ? EditRetailStoreVerificationData(2) : setStep(1);
				break;
			case 3:
				flag === 1 ? EditRetailStoreVerificationData(3) : setStep(2);
				// if (flag === 1) {
				// 	const addedImages = props.imageTagData
				// 		? props.imageTagData.addedImages || []
				// 		: [];
				// 	if (addedImages.length < 1)
				// 		props.context.showAlert(
				// 			"Please take minimum of 1 pictures",
				// 			"error",
				// 		);
				// 	else EditRetailStoreVerificationData(3);
				// } else {
				// 	setStep(2);
				// }
				break;
			case 4:
				if (flag === 1) {
					if (
						isConfirmCustomerLocation === "NO" &&
						!props.context.userLocation.longitude
					) {
						navigator.geolocation.watchPosition(
							position => {
								window.location.reload();
							},
							error => {
								props.context.showAlert("Please enable GPS access", "error");
							},
						);
					} else {
						EditRetailStoreVerificationData(4);
					}
				} else {
					setStep(3);
				}
				break;
			default:
				flag === 1
					? EditRetailStoreVerificationData(5)
					: flag === 0
					? setStep(4)
					: props.setFirstTimeOrder(1);
		}
	};
	const GetRetailStoreVerificationData = async () => {
		const result = await GET(
			`Store/GetRetailStoreVerificationData?Customerid=${props.orderDetails.Customerid}&orderId=${props.orderDetails.Orderid}`,
		);
		if (!result.error && result.OutletDetails) {
			setShowLoading(false);
			setRetailStoreData(result.OutletDetails[0]);
			const address = await props.context.getUserAddress("Add Customer");
			setStoreAddress(address || result.OutletDetails[0].storeAddress);
			setStoreImages(result.OutletDetails[0].storeImages || []);
			setFullName(result.OutletDetails[0].fullName);
			setStoreName(result.OutletDetails[0].storeName);
			if (result.OutletDetails[0].Step < 5)
				setStep(result.OutletDetails[0].Step + 1);
			else {
				props.setFirstTimeOrder(1);
			}
		} else {
			setShowLoading(false);
		}
	};

	const EditRetailStoreVerificationData = async step => {
		try {
			setShowLoader(true);
			let RetailData = new FormData();
			RetailData.set("step", step);
			RetailData.set("Customerid", props.orderDetails.Customerid);
			RetailData.set("OrderID", props.orderDetails.Orderid);
			step === 1 && RetailData.set("storeDescription", isConfirmRetailStore);
			step === 2 && RetailData.set("fullName", fullName);
			step === 2 && RetailData.set("storeName", storeName);
			step === 2 && RetailData.append("phone", retailStoreData.storePhone);
			if (step === 3) {
				(props.imageTagData.addedImages || []).forEach((image, i) => {
					RetailData.set(`${image.tagId}`, image.file);
				});
			}
			if (step === 4) {
				RetailData.set(
					"location",
					isConfirmCustomerLocation === "NO"
						? storeAddress
						: isConfirmCustomerLocation,
				);
				RetailData.set("latitude", latitude);
				RetailData.set("longitude", longitude);
			}
			step === 5 && RetailData.set("storeDescription", "Order Verification");
			const result = await POST(
				"store/EditRetailStoreVerificationData",
				RetailData,
			);
			if (!result.error) {
				setShowLoader(false);
				step === 5 ? props.setFirstTimeOrder(1) : setStep(step + 1);
				if (step === 4) {
					props.context.showAlert(
						"Retailer Profile updated successfully",
						"success",
					);
				}
			} else {
				setShowLoader(false);
				props.showAlert("An error occured. Please try again", "error");
			}
		} catch (error) {
			setShowLoader(false);
		}
	};
	const removeAddedImage = async (i, image) => {
		let imgList = [];
		storeImages.forEach((img, index) => {
			if (index !== i) imgList.push(img);
		});
		setStoreImages(imgList);
		if (image.customerImageId) {
			let fd = new FormData();
			fd.set("Agentid", props.context.userId);
			fd.set("Flag", 3);
			fd.set("CustomerImageID", image.customerImageId);
			fd.set("ReasonDate", new Date().toISOString());
			fd.set("Reason", "");
			fd.set("ReasonBy", props.context.userId);
			fd.set("CustomerId", props.orderDetails.Customerid);
			await POST("addressbook/AddBusinessCustomerImage", fd);
		}
	};
	return (
		<Fragment>
			{showLoading ? (
				<Loading size={"4px"} margin={"80px auto 150px"} />
			) : (
				<div>
					<div className="customer__location">
						<div className="customer__location__header">
							{/* {step > 1 && (
									<img
										src="Images/dark-back.svg"
										alt=""
										onClick={() =>
											setStep(step - 1)
										}
										className="no-print"
										style={{
											width: "16px"
										}}
									/>
								)} */}
							<div className="customer__location__header__flex__between">
								<span
									className={`${props.orderDetails.OrderStatus.toLowerCase()}`}
								>
									{props.orderDetails.OrderStatus}
								</span>
								<div className="customer__location__header__first__order">
									First Order
								</div>
							</div>
							<div className="customer__location__header__data">
								<div style={{ flexGrow: 1 }}>
									<div className="customer__location__header__name">
										{props.orderDetails.CustomerName}
									</div>
									<div className="customer__location__header__order__id">
										Order #{props.orderDetails.Orderid}
									</div>
									<div className="customer__location__header__date">
										Order date:{" "}
										{dayjs(props.orderDetails.Createddate).format(
											`MMM D, YYYY.${
												window.screen.width > 350 ? "h:mm a" : ""
											}`,
										)}{" "}
									</div>
								</div>
								<div className="flex" style={{ alignItems: "flex-end" }}>
									{props.orderDetails.CustomerPhone && (
										<div
											className="invoice-details-body-project-user-contact flex align-center"
											onClick={() =>
												(window.location.href = `tel:${props.orderDetails.CustomerPhone}`)
											}
										>
											<img
												src="Images/dark-call.svg"
												width="24px"
												height="30px"
												alt="call"
											/>
										</div>
									)}
									<span
										onClick={() =>
											window.open(
												`https://api.whatsapp.com/send?phone=234${props.orderDetails.CustomerPhone.substring(
													1,
													11,
												)}`,
												"_blank",
											)
										}
									>
										<img
											src="Images/whatsapp-icon.svg"
											width="25px"
											height="25px"
											alt="whatsapp"
										/>
									</span>
									{/* <img
											src="Images/downloadicon.png"
											width="36px"
											height="36px"
											alt="download"
										/> */}
								</div>
							</div>
						</div>

						<div className="customer__location__step">
							<div className="customer__location__step__flex">
								<div className="customer__location__step__flex__steps">
									<div className="verification-steps-ring">
										<CompletionRing
											radius={40}
											stroke={6}
											successColor={"#6AC259"}
											backgroundColor={"#fff"}
											successPercent={1}
											progress={(step / 5) * 100}
											progressText={`<div class="progress-text-cont"><div class="progress-text-cont-stat">${step} of ${5}</div></div>`}
										/>
									</div>
								</div>
								<div>
									<div className="customer__location__step__flex__label">
										{step === 1
											? "Retail Store Verification"
											: step === 2
											? "Basic Details Verification"
											: step === 3
											? "Store Images Verification"
											: step === 4
											? "Location Verification"
											: step === 5 && "Order Verification"}
									</div>
									<div className="customer__location__step__flex__info">
										{step === 1
											? "Next: Basic Details"
											: step === 2
											? "Next: Store Image"
											: step === 3
											? "Next: Location"
											: step === 4 && "Next: Order"}
									</div>
								</div>
							</div>
						</div>

						<div className="customer__location__body">
							{step === 1 ? (
								<>
									<div className="customer__location__body__box">
										<div className="customer__location__body__box__label">
											Welcome to Omnibiz. We are pleased to receive your order.
											Since this is your first time ordering with us I would
											like to extend a discount to you and to avail you this
											opportunity you will need to help me complete your
											profile.
										</div>
									</div>
									<div
										className="customer__location__body__box"
										style={{ marginTop: "20px" }}
									>
										<div className="customer__location__body__box__label">
											Can you please confirm if your shop is a retail store.
										</div>
										<Radio
											label={"Yes"}
											checked={isConfirmRetailStore === "YES" ? true : false}
											onChange={() => null}
											onClick={() => setConfirmRetailStore("YES")}
											value={isConfirmRetailStore}
											id={1}
										/>

										<Radio
											label={"No"}
											checked={isConfirmRetailStore === "NO" ? true : false}
											onChange={() => null}
											onClick={() => setConfirmRetailStore("NO")}
											value={isConfirmRetailStore}
											id={2}
										/>
									</div>
								</>
							) : step === 2 ? (
								<div className="customer__location__body__box">
									<div className="customer__location__body__box__confirm">
										Kindly confirm your full name, phone number and your Store
										name.
									</div>
									<div style={{ marginTop: "10px" }}>
										<Input
											value={fullName}
											onChange={evt => {
												setFullName(evt.target.value);
											}}
											withMargin={true}
											label={"Full Name"}
											placeholder={"Mustapha Idris"}
											required={true}
											requiredStar={true}
										/>
									</div>
									<div style={{ marginTop: "10px" }}>
										<Input
											value={storeName}
											onChange={evt => {
												setStoreName(evt.target.value);
											}}
											withMargin={true}
											label={"Store Name"}
											placeholder={"Mustapha and Sons Store"}
											required={true}
											requiredStar={true}
										/>
									</div>
									<div style={{ marginTop: "10px" }}>
										<Input
											value={retailStoreData.storePhone}
											withMargin={true}
											label={"Phone Number"}
											placeholder={"0123456789"}
											disabled={true}
										/>
									</div>
								</div>
							) : step === 3 ? (
								<>
									<div className="customer__location__body__box">
										<div className="customer__location__body__box__confirm">
											I have just sent you a message on whatsapp. Can you please
											check and share 3 good photos of your store (Outside far,
											Outside near, Inside).
										</div>
										{storeImages && (
											<Fragment>
												<div className="customer__location__body__box__confirm__label">
													Uploaded Images
												</div>
												<div className="customer__location__body__box__confirm__images">
													{storeImages.map((img, i) => (
														<div
															key={i}
															className="default-contact-images-each"
														>
															<img
																src={`${asset_url}${img.image}`}
																style={{
																	width: "120px",
																	height: "100px",
																	objectFit: "cover",
																}}
																alt="retail_outlet"
															/>
															<span onClick={() => removeAddedImage(i, img)}>
																&times;
															</span>
															{img.tagName && <p>{img.tagName}</p>}
														</div>
													))}
												</div>
											</Fragment>
										)}
										<div className="customer__location__body__box__confirm__upload__new">
											Upload new collected Images
										</div>
										<OutletPhoto
											setShowImageTagging={props.setShowImageTagging}
											imageTagData={props.imageTagData}
										/>
									</div>
								</>
							) : step === 4 ? (
								<>
									<div className="customer__location__body__box">
										<div className="customer__location__body__box__distance">
											{`You are ${
												_getLocationDistances(
													retailStoreData.storeLatitude || latitude,
													retailStoreData.storeLongitude || longitude,
													latitude,
													longitude,
												) || "0 m"
											} from the registered location`}
										</div>
										<div className="customer__location__body__box__label">
											Kindly confirm customer location as
										</div>
										<div className="customer__location__body__box__address__location">
											<span>
												<img
													src="Images/location.png"
													alt="location"
													width="10"
													height="12"
												/>
											</span>

											<span className="customer__location__body__box__address">
												{retailStoreData.storeAddress}
											</span>
										</div>
										<Radio
											label={"Yes"}
											checked={
												isConfirmCustomerLocation === "YES" ? true : false
											}
											onChange={() => null}
											onClick={() => setConfirmCustomerLocation("YES")}
											value={isConfirmCustomerLocation}
											id={1}
										/>

										<Radio
											label={"No"}
											checked={
												isConfirmCustomerLocation === "NO" ? true : false
											}
											onChange={() => null}
											onClick={() => {
												getAddress();
											}}
											value={isConfirmCustomerLocation}
											id={2}
										/>
										{isConfirmCustomerLocation === "NO" && (
											<div style={{ position: "relative" }}>
												<span className="customer__location__body__box__location__img">
													<img
														src="Images/location.png"
														width="16"
														height="20"
														alt="location"
													/>
												</span>
												<div
													className={`default-contact-input ${
														1 ? "default-contact-input-address" : ""
													}`}
												>
													<Input
														label={"Customer Location"}
														value={storeAddress}
														disabled={true}
														withIcon={"30px"}
													/>
													{1 && (
														<span
															onClick={() => setupdateCustomerLocation(true)}
														>
															<img src="Images/googlemaps.svg" alt="" />
															Update
														</span>
													)}
												</div>
											</div>
										)}
									</div>
								</>
							) : (
								<>
									<div className="customer__location__body__box">
										<div className="customer__location__body__box__label">
											We are pleased to recieve your order. For accurate
											delivery and seemless experience Can you please help me
											verify the products you have ordered.
										</div>
									</div>
									<div className="customer__location__body__box__order">
										<div className="customer__location__body__box__order__label">
											Order
										</div>

										{props.orderDetailRetail.OnlineOrder.length ? (
											<div className="payment-history">
												{props.orderDetailRetail.OnlineOrder.map(
													(Item, index) => (
														<div className="customer__location__body__box__order__item">
															<div className="customer__location__body__box__order__item__flex">
																<div className="customer__location__body__box__order__item__flex__order">
																	<div className="customer__location__body__box__order__item__flex__name">
																		{_capitalizeText(Item.ItemName || "")}
																	</div>
																	<div className="flex flex-between align-center">
																		<div className="customer__location__body__box__order__item__flex__label">
																			Quantity: <span> {Item.Quantity}</span>
																		</div>
																		<div className="customer__location__body__box__order__item__flex__label">
																			Price:{" "}
																			<span>{_formatCurrency(Item.Price)}</span>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													),
												)}
											</div>
										) : null}
										<div
											className="flex flex-between align-center"
											style={{ marginTop: "10px" }}
										>
											<div className="customer__location__body__box__order__total">
												Total :
											</div>
											<div className="customer__location__body__box__order__total">
												{_formatCurrency(props.orderDetails.TotalPrice)}
											</div>
										</div>
									</div>
								</>
							)}
						</div>
						<div className="modal-submit">
							{step > 1 && (
								<Button
									type={"default"}
									text={"Back"}
									onClick={() => submitSteps(0)}
								/>
							)}
							<Button
								type={"primary"}
								text={"Next"}
								onClick={() => submitSteps(1)}
								loading={showLoader}
								disabled={
									step === 2 ? (fullName && storeName ? false : true) : false
								}
							/>
						</div>
					</div>
				</div>
			)}
			{updateCustomerLocation && (
				<UpdateCustomerLocation
					close={() => setupdateCustomerLocation(false)}
					longitude={Number(props.context.userLocation.longitude || "0")}
					latitude={Number(props.context.userLocation.latitude || "0")}
					address={storeAddress}
					initialLocation={props.context.userLocation}
					allowUpdate={true}
					updateLocation={(longitude, latitude, address) => {
						setStoreAddress(address);
						setupdateCustomerLocation(false);
						setLatitude(latitude);
						setLongitude(longitude);
					}}
				/>
			)}
		</Fragment>
	);
};

export default CallAgentVerification;
